var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid_card",class:{
        'grid_card--full': _vm.isFull,
        'grid_card--no_padding': _vm.noPadding,
        'grid_card--stretch': !_vm.hasContent,
    }},[(_vm.title || _vm.hasComment || _vm.hasHeaderSlot)?_c('div',{staticClass:"grid_card-header"},[(_vm.title)?_c('h5',{staticClass:"grid_card-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("header"),(_vm.hasComment)?_c('comment-button'):_vm._e()],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }